export const NAME_REGEX = /^[A-Za-z\s\-']+$/;
export const ALPHANUMERIC_REGEX = /^[A-Za-z0-9\s\-']+$/;
export const CITY_REGEX = /^[A-Za-z\s\-']+$/;
export const STATE_REGEX = /^[A-Za-z\s\-]+$/;
export const ZIPCODE_REGEX = /^[A-Z0-9\s\-]+$/i;
export const MAX_NAME_LENGTH = 50;
export const MAX_CITY_LENGTH = 100;
export const MAX_STATE_LENGTH = 50;
export const MIN_ZIPCODE_LENGTH = 2;
export const MAX_ZIPCODE_LENGTH = 20;
